import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { ApiService } from '../../../../../../core/services/api.service';
import { EditTransactionLicenseData } from '../../../../../../core/models/parking.model';
import { PatchCorrectLicensePayload } from '../../../../../../core/models/vehicle.model';
import { ActionBackOfficeResponse } from '../../../../../../core/models/api.model';

@Component({
  selector: 'app-modal-transaction-parking-edit-license',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-transaction-parking-edit-license.component.html',
  styleUrl: './modal-transaction-parking-edit-license.component.css'
})
export class ModalTransactionParkingEditLicenseComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() data: EditTransactionLicenseData = {
    userId: 0,
    oldLicense: '',
    transactionId: 0,
    entryPath1: ''
  };
  @Output() onClose = new EventEmitter<void>();
  @Output() onSuccess = new EventEmitter<void>();

  private readonly api = inject(ApiService);
  private readonly toast = inject(ToastService);
  private readonly cookieService = inject(CookieService);

  newLicense: string = '';
  isLoading: boolean = false;
  userId: string = '';
  isImageZoomed: boolean = false;

  constructor() {
    this.userId = this.cookieService.get('user_id');
  }

  // ================= Normal Functions =================

  /**
   * ตรวจสอบการเปลี่ยนแปลงของข้อมูล Input เพื่อรีเซ็ตค่าทะเบียนใหม่เมื่อเปิด Modal
   * Angular lifecycle hook triggered when input properties change.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.isOpen) {
      this.newLicense = '';
      this.isImageZoomed = false;
    }
  }

  /**
   * ดึงลิงก์ของรูปภาพรถยนต์ตอนเข้า (หรือออก) สำหรับแสดงภาพเปรียบเทียบในฝั่งซ้ายของ Modal
   * Returns the constructed LPR image URL or a placeholder if no image exists.
   */
  get imageUrl(): string {
    const path = this.data.entryPath1;
    return path ? `https://pss-upload.cloud/Parkingcaptures/${path}` : 'img/notfound.jpg';
  }

  /**
   * ส่ง Event เพื่อสั่งปิด Modal
   * Emits the close event to notify the parent component.
   */
  closeModal(): void {
    this.onClose.emit();
  }

  // ================= API Functions =================

  /**
   * ส่งคำขอแก้ไขเลขทะเบียนรถไปยัง API ของระบบ Back Office
   * Calls the API service to update the parking transaction license plate.
   */
  save(): void {
    if (!this.newLicense) {
      this.toast.warn('กรุณากรอกเลขทะเบียนใหม่');
      return;
    }

    if (this.newLicense === this.data.oldLicense) {
      this.toast.warn('เลขทะเบียนใหม่ต้องไม่ซ้ำกับเลขทะเบียนเดิม');
      return;
    }

    this.isLoading = true;

    const payload: PatchCorrectLicensePayload = {
      userId: Number(this.userId),
      licensesOld: this.data.oldLicense,
      licensesNew: this.newLicense
    };

    console.log('Sending patchCorrectLicense payload:', payload, this.data.transactionId);

    this.api.patchCorrectLicense(payload, this.data.transactionId).subscribe({
      next: (res: ActionBackOfficeResponse) => {
        if (res.isSuccess) {
          this.toast.success('แก้ไขทะเบียนเรียบร้อยแล้ว');
          this.onSuccess.emit();
          this.closeModal();
        } else {
          this.toast.error(res.message || 'เกิดข้อผิดพลาดในการแก้ไขทะเบียน');
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error('patchCorrectLicense error:', err);
        this.toast.error(err.error?.message || 'เกิดข้อผิดพลาดในการแก้ไขทะเบียน');
        this.isLoading = false;
      }
    });
  }
}
